import { createClient, configureChains } from 'wagmi';

import { avalanche, avalancheFuji } from 'wagmi/chains';

// import { infuraProvider } from 'wagmi/providers/infura';
import { publicProvider } from 'wagmi/providers/public';
import { isMainnet } from 'utils';

import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { InjectedConnector } from 'wagmi/connectors/injected';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';

import { WalletNames } from 'types';

import { walletConnectKey } from '../config-env';

export const supportedChains = [isMainnet() ? avalanche : avalancheFuji];

const { chains, provider, webSocketProvider } = configureChains(supportedChains, [
  // infuraProvider({ apiKey: 'a8cf7bf8f91d46dab0e1aa8125c941ed' }),
  publicProvider(),
]);

const client = createClient({
  autoConnect: true,
  connectors: [
    new InjectedConnector({
      chains,
      options: {
        name: WalletNames.Core,
        //@ts-ignore
        getProvider: () => (window?.ethereum?.coreProvider ? window.ethereum.coreProvider : undefined),
      },
    }),
    new InjectedConnector({
      chains,
      options: {
        name: WalletNames.Metamask,
        getProvider: () => (window?.ethereum ? window.ethereum : undefined),
      },
    }),
    new CoinbaseWalletConnector({
      chains,
      options: {
        appName: 'wagmi',
      },
    }),
    new WalletConnectConnector({
      chains,
      options: {
        qrcode: true,
        version: '2',
        projectId: walletConnectKey || '',
      },
    }),
  ],
  provider,
  webSocketProvider,
});

export default client;
